import GravityV3Adapter from 'teacher-ui-client/adapters/gravity/v3-adapter'
import { service } from '@ember/service'
import { assert } from '@ember/debug'
import type SessionService from 'teacher-ui-client/services/session'

export default class SubscriptionUtilisationAdapter extends GravityV3Adapter {
  @service session!: SessionService

  urlForQuery(...args: Parameters<GravityV3Adapter['urlForQuery']>) {
    const [query, ...other] = args
    const { currentTeacher } = this.session

    assert('currentTeacher.id missing', currentTeacher?.id)

    const url = super.urlForQuery(query, ...other)
    return url.replace('/subscription-utilisations', `/teachers/${currentTeacher.id}/subscription-utilisations`)
  }
}
